export enum InvestorSigningStatus {
	NOT_SIGNED = 'NOT_SIGNED',
	SIGNED_SELF_ONLY = 'SIGNED_SELF_ONLY',
	SIGNED_PIV_ONLY = 'SIGNED_PIV_ONLY',
	PENDING_WITNESS = 'PENDING_WITNESS',
}
